angular.module('angularutilities', [])
.service('currencyFormatService', function($filter) {
	return {
		name: 'currencyFormatService',
		get: function(d, currencySymbol) {
			var isNegative = false;
			var numberFormat = '';
			if (d < 0) {
				// changes from a negative string to a positive number
				d = d * -1;
				isNegative = true;
			}

			if (d >= 1000000) {
				numberFormat = 'M';
				d = d3.format('.2f')(d / 1000000);
			} else if (d >= 1000) {
				numberFormat = 'K';
				d = d3.format('.2f')(d / 1000);
			} else if (d % 1 === 0) {
				d = '' + d;
			} else {
				d = d3.format('.2f')(d);
			}

			if (isNegative) {
				// change back to a negative string
				d = (d * -1).toString();
			}
			var decimals = 0;
			var numSplit = d.split('.');
			if (numSplit && numSplit.length && numSplit.length === 1) {
				decimals = 0;
			} else {
				if (numSplit[1].length && numSplit[1].length === 1) {
					decimals = 1;
				} else if (numSplit[0].length && numSplit[0].length >= 2) {
					decimals = 1;
				} else {
					decimals = 2;
				}
			}
			return $filter('currency')(d,
				typeof currencySymbol === 'undefined' ?
					globalConfig.browser.currencySymbol :
					currencySymbol, decimals
			) + numberFormat; 
		},
		getWithParameters: function(d, dec, currencySymbol) {
			var isNegative = false;
			if (d < 0) {
				d = d * -1;
				isNegative = true;
			}
			return $filter('currency')(d, typeof currencySymbol === 'undefined' ? globalConfig.browser.currencySymbol : currencySymbol, dec);
		},
		getWithParametersNegativeSign: function(d, dec, currencySymbol) {
			var isNegative = false;
			if (d < 0) {
				d = d * -1;
				isNegative = true;
			}
			var neg = '';
			if (isNegative)
				neg = '-';
			return neg+$filter('currency')(d, typeof currencySymbol === 'undefined' ? globalConfig.browser.currencySymbol : currencySymbol, dec);
		}
	};
})

.service('numberFormatService', function($filter, $locale) {
	
	function getDecimalPlaces(number) {
	  // toFixed produces a fixed representation accurate to 2 decimal places
	  // without an exponent.
	  // The ^-?\d*\. strips off any sign, integer portion, and decimal point
	  // leaving only the decimal fraction.
	  // The 0+$ strips off any trailing zeroes.
	  return ((+number).toFixed(2)).replace(/^-?\d*\.?|0+$/g, '').length;
	}
	
	return {
		name: 'numberFormatService',
		get: function(d) {
			var isNegative = d < 0;
			if (isNegative) {
				d *= -1;
			}
			var numberFormat = '';
			if (d >= 1000000) {
				numberFormat = 'M';
				d = d3.format('.2f')(d / 1000000);
			} else if (d >= 1000) {
				numberFormat = 'K';
				d = d3.format('.2f')(d / 1000);
			} else {
				var decimalLength = getDecimalPlaces(d);
				if (decimalLength >= 2) {
					d = d3.format('.2f')(d);
				} else if (decimalLength === 1) {
					d = d3.format('.1f')(d);
				} else {
					d = d3.format('.0f')(d);
				}
			}
			var val = +parseFloat(d).toPrecision(3);
			if (isNegative) {
				val = '-' + val;
			}
			return val + numberFormat;
		},
		getWithParameters: function(d, dec, keepNegativeSign) {
			var isNegative = d < 0;
			if (isNegative) {
				d = d * -1;
			}
			var formattedNumber = $filter('number')(d, dec);
			if (keepNegativeSign && isNegative) {
				formattedNumber = '-' + formattedNumber;
			}
			return formattedNumber;
		},
		getOriginalNumber: function (d) {
			var alloweValuesRegex = new RegExp('[^0-9-' + $locale.NUMBER_FORMATS.GROUP_SEP + $locale.NUMBER_FORMATS.DECIMAL_SEP + ']', ['g']);
			var cleanedNumber = d.replace(alloweValuesRegex, '');
			var numberPartition = cleanedNumber.split($locale.NUMBER_FORMATS.DECIMAL_SEP);
			var deFormmattedValue = numberPartition[0].split($locale.NUMBER_FORMATS.GROUP_SEP).join('');
			if (numberPartition.length > 2) {
				return NaN;
			} else if (numberPartition.length === 2) {
				deFormmattedValue += '.' + numberPartition[1].split($locale.NUMBER_FORMATS.GROUP_SEP).join('');
			}
			return deFormmattedValue;
		}
	};
})

.service('percentageFormatService', function($filter) {
	return {
		name: 'percentageFormatService',
		get: function(d) {
			var prec = '.0%';
			if (d < 10 && d > 0 && (d * 10) % 1 != 0) {
				prec = '.2%';
			} else if (d < 100 && d % 1 != 0) {
				prec = '.1%';
			}
			return d3.format(prec)(d/100);
		},
		getWithParameters: function(d, dec) {
			var prec = 0;
			if (d < 10 && d > -10 && (d * 10) % 1 != 0) {
				prec = 2;
			} else if (d < 100 && d > -100 && d % 1 != 0) {
				prec = 1;
			}
			if (dec || dec == 0) {
				prec = dec;
			}
			return $filter('number')(d, prec) + '%';
		}
	};
})

.service('integerFormatService', function($filter) {
	return {
		name: 'integerFormatService',
		get: function(d) {
			var numberFormat = '';
			if (d >= 1000000) {
				numberFormat = 'M';
				d = d3.format('.2f')(d / 1000000);
			} else if (d >= 1000) {
				numberFormat = 'K';
				d = d3.format('.2f')(d / 1000);
			} else {
				d = d3.format('.0f')(d);
			}
			var val = +parseFloat(d).toPrecision(3);
			return val + numberFormat;
		},
		getWithParameters: function(d, dec, keepNegativeSign) {
			var isNegative = d < 0;
			if (isNegative) {
				d = d * -1;
			}
			var formattedNumber = $filter('number')(d, dec);
			if (keepNegativeSign && isNegative) {
				formattedNumber = '-' + formattedNumber;
			}
			return formattedNumber;
		}
	};
})

.service('getJsonData', function($q, $http) {
	return {
		get: function(path) {
			var deferred = $q.defer();
			$http.get(path)
			.then(function(response) {
				// FIXME: this returns an error for 204 as well, which is wrong
				if (response && response.data) {
					deferred.resolve(response.data);
				} else {
					deferred.reject();
				}
			})
			.catch(function() {
				deferred.reject('An Error Occurred');
			});
			return deferred.promise;
		}
	};
})

.service('slideshowControls', function() {
	var self = this;
	self.paused = false;
	self.transitionTime = 10000;
	self.startAtLast = false;
	self.noWidgets = false;
	self.startingPath = '';
	self.seenWidget = false;
	self.initialLoad = false;
})

.service('weeklyDiffService', function($translate) {
	return {
		getDataPoints: function(data) {
			var diff = {
				lastDataPoint: null,
				previousDataPoint: null
			};
			// cutoffDate is monday from two weeks ago, where monday is first day of week
			diff.lastDataPoint = data[data.length - 1];
			var twoWeeksPrior = moment(diff.lastDataPoint.dateLog).subtract(2, 'weeks');
			var deltaCutoffDate = moment(twoWeeksPrior).day(1);
			if (deltaCutoffDate.isAfter(twoWeeksPrior)) {
				// moment starts week on sunday so move back a week if moment moved forwards when setting to monday
				deltaCutoffDate.subtract(1, 'week');
			}
			// find first data after cutoff date
			for (var index in data) {
				var dateData = data[index];
				if (moment(dateData.dateLog).isAfter(deltaCutoffDate)) {
					diff.previousDataPoint = dateData;
					return diff;
				}
			}
		},
		getAdditionalLabelText: function(previousDataPoint) {
			return $translate.instant('since {{formattedDate}}', {formattedDate: moment(previousDataPoint.dateLog).format('MMM D, YYYY')});
		}
	};
})

.directive('tagOnBlur', function($timeout) {
	return {
		require: 'uiSelect',
		link: function(scope, elm, attrs, ctrl) {
			ctrl.searchInput.on('blur', function() {
				if ((ctrl.items.length > 0 || ctrl.tagging.isActivated)) {
					$timeout(function() {
						ctrl.searchInput.triggerHandler('tagged');
						var newItem = ctrl.search;
						if ( ctrl.tagging.fct ) {
							newItem = ctrl.tagging.fct( newItem );
						}
						if (newItem) ctrl.select(newItem, true);
					});
				}
			});
		}
	};
})

.controller('confirmDialogCtrl', ['$scope', function ($scope) {
	var messages = {
		'disable Data API and delete all API keys for this user': 'modal.confirm.disableDataApi',
		'disable super system administrator access for this user': 'modal.confirm.disableSuperSystemAdmin',
		'enable super system administrator access for this user': 'modal.confirm.enableSuperSystemAdmin',
		'mimic this user session': 'modal.confirm.mimicSession',
		'approve this project': 'modal.confirm.approveProject',
		'validate this project': 'modal.confirm.validateProject',
		'delete this project': 'modal.confirm.deleteProject',
		'archive this project': 'modal.confirm.archiveProject',
		'delete this project type': 'modal.confirm.deleteProjectType',
		'delete this project template': 'modal.confirm.deleteProjectTemplate',
		'delete this task': 'modal.confirm.deleteTask',
		'delete this task and any associated attachments': 'modal.confirm.deleteTaskAndAttachments',
		'delete this stage': 'modal.confirm.deleteStage',
		'delete this project saving category': 'modal.confirm.deleteProjectSavingCategory',
		'delete this custom field': 'modal.confirm.deleteCustomField',
		'delete this value': 'modal.confirm.deleteCustomFieldValue',
		'delete this project area': 'modal.confirm.deleteProjectArea',
		'delete this goal': 'modal.confirm.deleteGoal',
		'delete this metric': 'modal.confirm.deleteMetric',
		'delete this metric result': 'modal.confirm.deleteMetricResult',
		'delete this member': 'modal.confirm.deleteMember',
		'delete this issue': 'modal.confirm.deleteIssue',
		'delete this widget': 'modal.confirm.deleteWidget',
		'delete this report card parameter': 'modal.confirm.deleteReportCardParameter',
		'delete this value stream': 'modal.confirm.deleteValueStream',
		'archive this Savings Category': 'modal.confirm.archiveSavingsCategory',
		'activate this Savings Category': 'modal.confirm.activateSavingsCategory',
		'archive this project category': 'modal.confirm.archiveProjectCategory',
		'activate this project category': 'modal.confirm.activateProjectCategory',
		'archive this goal': 'modal.confirm.archiveGoal',
		'activate this goal': 'modal.confirm.activateGoal',
		'change goal period type': 'modal.confirm.changeGoalPeriodType',
		'delete this Public Key': 'modal.confirm.deletePublicKey',
		'delete this LeanDNA Connect Key': 'modal.confirm.deleteConnectKey',
		'enable this supplier delivery cause': 'modal.confirm.enableSupplierDeliveryCause',
		'archive this supplier delivery cause': 'modal.confirm.archiveSupplierDeliveryCause',
		'Enable this Supply Order status category': 'modal.confirm.enableSupplyOrderStatusCategory',
		'Archive this Supply Order status category': 'modal.confirm.archiveSupplyOrderStatusCategory',
		'Enable this Customer Order status category': 'modal.confirm.enableCustomerOrderStatusCategory',
		'Archive this Customer Order status category': 'modal.confirm.archiveCustomerOrderStatusCategory',
		'deactivate this field for external users': 'modal.confirm.deactivateFlexField',
		'disable this Profile': 'modal.confirm.disableSsoProfile',
		'archive this Unable to Fix category': 'modal.confirm.archiveUnableToFixCategory',
		'archive these Unable to Fix categories': 'modal.confirm.archiveUnableToFixCategories',
		'archive this unable to fix category': 'modal.confirm.archiveUnableToFixCategory',
		'archive this Procurement Task category': 'modal.confirm.archiveProcurementTaskCategory',
		'archive these Procurement Task categories': 'modal.confirm.archiveProcurementTaskCategories',
		'enable this Procurement Task category': 'modal.confirm.enableProcurementTaskCategory',
		'change site to All': 'modal.confirm.changeSiteToAll'
	};
	var checkboxMessages = {
		'This will delete all associated metric results and targets:  ': 'modal.confirm.deleteMetricCheckbox',
		'This will delete all associated metric targets:  ': 'modal.confirm.changeGoalPeriodTypeCheckbox'
	};

	if (!$scope.messageKey) {
		var action = ($scope.additionalText || '').replace(/^\s+/, '');
		if (action === 'delete this Profile' && $scope.prefixText) {
			$scope.messageKey = 'modal.confirm.deleteActiveSsoProfile';
		} else if (action === 'delete this Profile') {
			$scope.messageKey = 'modal.confirm.deleteSsoProfile';
		} else {
			$scope.messageKey = messages[action];
		}
	}
	if (!$scope.messageValues) {
		$scope.messageValues = {};
	}
	if ($scope.checkboxMessage && checkboxMessages[$scope.checkboxMessage]) {
		$scope.checkboxKey = checkboxMessages[$scope.checkboxMessage];
	}
	if (!$scope.fallbackText) {
		$scope.fallbackText = ($scope.prefixText || '') + 'Are you sure you want to ' + ($scope.additionalText || '') + '?' + ($scope.postfixText ? ' ' + $scope.postfixText : '');
	}
}]);

// Global functions
function confirm($scope, $uibModal, prefixText, additionalText, buttonText, cbFunction) {
	var confirmScope = $scope.$new();
	confirmScope.additionalText = additionalText;
	confirmScope.prefixText = prefixText;
	confirmScope.buttonText = buttonText;
	var opts = {
		scope: confirmScope,
		templateUrl: '/application/f/core/confirm.html'
	};

	var instance = $uibModal.open(opts);
	confirmScope.closeDialog = function() {
		instance.close();
		confirmScope.$destroy();
	};
	
	confirmScope.yes = function() {
		instance.close();
		confirmScope.$destroy();
		cbFunction();
	};
}

var globalReportName = '';